import { SSEService } from '@/shared/services/sse';

export const SSETalkSmsChannel = SSEService.createEventChannel('talk.sms');
export const SSETalkFaxChannel = SSEService.createEventChannel('talk.fax');
export const SSETalkNumberChannel = SSEService.createEventChannel('talk.number');
export const SSETalkExtensionChannel = SSEService.createEventChannel('talk.extension');
export const SSETalkEndpointChannel = SSEService.createEventChannel('talk.endpoint');
export const SSETalkEndpointRegisterChannel = SSEService.createEventChannel('talk.endpoint.register');
export const SSETalkAccessChannel = SSEService.createEventChannel('talk.access');
export const SSETalkMediaChannel = SSEService.createEventChannel('talk.media');
// Published to one account — the tester's — never to the tenant. Live feedback for an AI-agent
// draft test: deliberately free of prompt text, caller detail and tool arguments.
export const SSETalkAiAgentTestChannel = SSEService.createEventChannel('talk.ai-agent-test');
export const SSETalkSoftphoneCallChannel = SSEService.createEventChannel('talk-softphone.call');
export const SSETalkCallsChannel = SSEService.createEventChannel('talk-calls');
